import { useState, useEffect } from 'react';
import { pw_change } from '../Board/DynamicBoard/clientAction'; // 비밀번호 변경 API 호출 함수 임포트

const usePasswordChange = () => {
  const [showPasswordChangePopup, setShowPasswordChangePopup] = useState(false); // 비밀번호 변경 팝업 상태
  const [pwChangeRow, setPwChangeRow] = useState(null); // 비밀번호 변경할 행의 데이터 저장

  // 상태가 변경될 때마다 콘솔에 로그 출력
  useEffect(() => {
  }, [showPasswordChangePopup]);

  // 비밀번호 변경 팝업 열기
  const handleOpenPasswordChangePopup = (row) => {
    setPwChangeRow(row); // 비밀번호 변경할 행 데이터 설정
    setShowPasswordChangePopup(true); // 팝업 열기
  };

  // 비밀번호 변경 팝업 닫기
  const handleClosePasswordChangePopup = () => {
    setShowPasswordChangePopup(false); // 팝업 닫기
  };

  // 비밀번호 변경 요청 처리
  const handlePasswordChangeSubmit = async (newPassword) => {
    //console.log('handlePasswordChangeSubmit 호출됨');
  
    try {
      // [이중알림 제거 2026-07-27] pw_change(clientAction)가 응답 status 기준으로 성공/실패 alert를 이미 냄.
      //   여기서 또 alert하면 404에도 성공 메시지가 겹쳐 떠서 "안 바뀌는데 성공"으로 오인됨.
      await pw_change({
        id: pwChangeRow.id,
        new_password: newPassword
      });
    } catch (error) {
      alert('오류가 발생했습니다.');
    } finally {
      //console.log('비밀번호 변경 처리 종료');
      handleClosePasswordChangePopup(); // 팝업 닫기
    }
  };

  return {
    showPasswordChangePopup,
    handleOpenPasswordChangePopup,
    handleClosePasswordChangePopup,
    handlePasswordChangeSubmit,
  };
};

export default usePasswordChange;